export default {
      id: "icon-select-box-arrow-usage",
      viewBox: "0 0 13.11 7.15",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-select-box-arrow",
      toString: function () {
        return this.url;
      }
    }